import { Link } from 'react-router-dom';
import { getHotArticles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function LatestArticles() {
  const hotArticles = getHotArticles().slice(0, 4);

  return (
    <section className="px-4 md:px-6 py-12 md:py-16 bg-background-50" aria-labelledby="articles-heading">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <h2 id="articles-heading" className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              最新文章
            </h2>
            <p className="text-sm text-foreground-600">
              影视资讯、观影指南、技术前沿，精彩内容每日更新
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-4">
          {hotArticles.map((article) => (
            <ArticleCard
              key={article.id}
              id={article.id}
              title={article.title}
              excerpt={article.excerpt}
              image={article.image}
              date={article.date}
              author={article.author}
              views={article.views}
              tags={article.tags}
            />
          ))}
        </div>
      </div>
    </section>
  );
}